import { ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Typography, makeStyles, styled } from '@material-ui/core';

import classNames from 'classnames';

import { RichOverflowTooltip } from '../RichOverflowTooltip';

export const SidebarValueWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  '& + *': {
    marginTop: theme.spacing(3),
  },
}));

const useStyles = makeStyles(theme => ({
  outerGrid: {
    display: 'grid',
    columnGap: theme.spacing(1),
    alignItems: 'self-start',
    color: theme.palette.text.secondary,
    gridTemplateColumns: '1fr',
  },
  iconGrid: {
    gridTemplateColumns: 'max-content 1fr',
  },
  textGrid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    minWidth: 0,
    overflowWrap: 'break-word',
  },
}));

export type SidebarValueProps = {
  name: string;
  value?: ReactNode;
  icon?: ReactNode;
  singleLine?: boolean;
  popover?: boolean;
};

export const SidebarValue = ({
  name,
  value,
  icon,
  singleLine,
  popover,
}: SidebarValueProps) => {
  const classes = useStyles();

  return (
    <div
      className={classNames(classes.outerGrid, { [classes.iconGrid]: !!icon })}
    >
      {icon}
      <div className={classes.textGrid}>
        <Typography
          color={popover ? 'textSecondary' : 'textPrimary'}
          variant={popover ? 'body2' : 'body1'}
        >
          {name}
        </Typography>
        {singleLine ? (
          <RichOverflowTooltip placement="bottom-start">
            <Typography
              component="span"
              variant={popover ? 'body2' : 'body1'}
              color={popover ? 'textPrimary' : 'inherit'}
            >
              {value}
            </Typography>
          </RichOverflowTooltip>
        ) : (
          <Typography
            component="div"
            variant={popover ? 'body2' : 'body1'}
            color={popover ? 'textPrimary' : 'inherit'}
          >
            {value}
          </Typography>
        )}
      </div>
    </div>
  );
};
